import { sendTrackingEvent } from 'tracking/utils/sendTrackingEvent';

export const sendNewMobilePdpBuyBarTrackingEvent = ({
  activeVariant,
  activeVariantPrice,
  buyNewPrice,
  buyUsedPrice,
  currencyCode = null,
  eventName,
  instantShipPrice,
  isApparelProduct = false,
  isUnderRetail = false,
  lastSold,
  makeOfferPrice,
  newStock = null,
  retailPrice,
  section,
  size,
  slug,
  topOffer = null,
  usedStock = null,
}) => {
  const lowestPricedNewBadBoxCondition =
    activeVariant?.newWithBoxIssues?.lowestPriceCents?.amountUsdCents || null;
  const lowestPricedBadBoxCondition =
    activeVariant?.newWithBoxIssues?.lastSoldPriceCents?.amountUsdCents || null;
  const lowestPricedNewWithDefects =
    activeVariant?.shoeCondition === 'new_with_defects'
      ? activeVariant?.lowestPriceCents?.amountUsdCents
      : null;
  const instantShipVariantPrice =
    instantShipPrice || activeVariant?.instantShipLowestPriceCents?.amountUsdCents || null;
  const lowestPricedUsedVariant =
    activeVariant?.shoeCondition === 'used'
      ? activeVariant?.lowestPriceCents?.amountUsdCents
      : null;
  const lowestPricedGoatCleanVariant =
    activeVariant?.shoeCondition === 'goat_clean'
      ? activeVariant?.lowestPriceCents?.amountUsdCents
      : null;

  sendTrackingEvent(eventName, {
    box_issue_last_sale: lowestPricedBadBoxCondition,
    buy_new_price: buyNewPrice,
    buy_used_price: buyUsedPrice,
    currency_code: currencyCode,
    event_context: 'buy_bar',
    is_apparel_product: isApparelProduct,
    make_offer_price: makeOfferPrice,
    new_box_issue_price: lowestPricedNewBadBoxCondition,
    new_instant_price: instantShipVariantPrice,
    new_standard_price: buyNewPrice,
    new_w_defects_price: lowestPricedNewWithDefects,
    newStock,
    price: activeVariantPrice,
    product_template_slug: slug,
    retailPrice,
    section,
    size,
    standard_last_sale: lastSold?.amountUsdCents || activeVariant?.lastSold?.amountUsdCents || null,
    standard_top_offer: topOffer,
    under_retail: isUnderRetail,
    used_clean_price: lowestPricedGoatCleanVariant,
    used_price: lowestPricedUsedVariant,
    usedStock,
  });
};
